import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DriverLicenceEndorsement } from '../../../model/licence.model';

@Component({
  selector: 'vrm-licence-endorsements-table',
  templateUrl: './licence-endorsements-table.component.html',
  styleUrls: ['./licence-endorsements-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LicenceEndorsementsTableComponent {
  @Input() public dataSource: DriverLicenceEndorsement[] = [];
  protected columns = [
    'convictionDate',
    'offenceDate',
    'disqualificationExpiryDate',
    'offenceCode',
    'points',
    'description',
  ];
}
